import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfeedbackrunner0postPostRunnerEventsResponseSchema = jsonObject
export type tcpfeedbackrunner0postPostRunnerEventsResponse = z.infer<typeof tcpfeedbackrunner0postPostRunnerEventsResponseSchema>
